import { Component, Input, OnInit } from '@angular/core';
import { Chart, ChartConfiguration, registerables } from 'chart.js/auto';
import { SseService } from 'src/app/services/sse/sse.service';
import { ConnectorState } from 'src/assets/js/constants';
import { Colors } from 'src/assets/js/colors';
import { TranslateService } from '@ngx-translate/core';

// Registrar componentes de Chart.js
Chart.register(...registerables);

@Component({
    selector: 'app-card-state',
    templateUrl: './card-state.component.html',
    standalone: false
})
export class CardStateComponent implements OnInit {

  canvasPie: any;
  ctxPie: any;
  chartPie: any;

  @Input()
  infoModulator: any;
  @Input()
  connectors: any;
  @Input()
  connectorsState: any = {};
  allStates = ConnectorState;

  constructor(private _sse: SseService, private _translate: TranslateService) { }

  ngOnInit(): void {
    this.loadGraphPie();
  }

  loadGraphPie() {
    this.canvasPie = document.getElementById("chartjs-card-pie");
    this.ctxPie = this.canvasPie.getContext("2d");

    const chartConfig: ChartConfiguration = {
      type: 'doughnut',
      data: {
        labels: ["Connected", "Disconnected", "Other"],
        datasets: [{
          data: this.infoModulator ?
            this.infoModulator?.stat.fvPower != null ?
              this.infoModulator?.stat.instPower < 0 ?
                [
                  this.infoModulator?.stat.instPower,
                  this.infoModulator?.stat.totalPower,
                  this.infoModulator?.stat.limitPower - (-this.infoModulator?.stat.instPower + this.infoModulator?.stat.totalPower)
                ] :
                [
                  this.infoModulator?.stat.totalPower - this.infoModulator?.stat.instPower,
                  this.infoModulator?.stat.instPower,
                  this.infoModulator?.stat.limitPower - this.infoModulator?.stat.totalPower
                ]
              :
              [
                0,
                this.infoModulator?.stat.totalPower,
                this.infoModulator?.stat.limitPower - this.infoModulator?.stat.totalPower
              ]
            : [],
          backgroundColor: this.infoModulator?.stat.fvPower != null ?
            [
              this.infoModulator?.stat.instPower > 0 ? Colors.yellow : Colors.accent_blue,
              this.infoModulator?.stat.instPower > 0 ? Colors.accent_blue : Colors.yellow,
              Colors.grey
            ]
            :
            [
              Colors.grey,
              Colors.accent_blue,
              Colors.grey
            ],
          borderColor: "transparent"
        }]
      }
    };

    this.chartPie = new Chart(this.ctxPie, chartConfig);

    this.canvasPie = document.getElementById("chartjs-card-pie-inside");
    this.ctxPie = this.canvasPie.getContext("2d");

  }

  getTranslatedText(translationKey: string) {
    return this._translate.instant(translationKey);
  }
}
